import axios from "axios";

// export const baseURL = "http://192.168.0.155:8084/xby";
export const baseURL = "http://jiaang.hongxuwuliu.com/xby/prod-api";
// export const baseURL = "http://192.168.0.190/xby/prod-api";
const service = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    return Promise.reject(err); // 返回错误
  }
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    return Promise.reject(err); // 返回错误
  }
);

export default service;
